/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */


import React, { Component } from 'react';
import './styles/css/account-info-4.css';
import { Button, Segment, Form, Input, Header, Dropdown, Checkbox, Progress } from 'semantic-ui-react';
import { Link, Redirect} from 'react-router-dom';
import API from "../utility/API";
import ProgressBar from "../components/progress-bar";

class AccountInfo3 extends Component {
  constructor() {
    super();
    this.state = {
      toNextPage: false,
      language: '',
      emailCommunication: false,
      textCommunication: false,
      shipmentNotification: false,
      docChangeNotification: false,
      customsResponseNotification: false,
      logisticsTrackingNotification: false,
      brokerNotification: false,
    }
  }
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  getCookieValue = (name) => {
    var b = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
  }

  toggle = (e, {name, value}) => this.setState({[name]: !value}, console.log(this.state)) 

  handleSubmit = () => {
    const { bondNumber, bondAmount, bond, bondType } = this.state
    this.setState({ bondNumber, bondAmount, bond, bondType })
    API.notifications(
      this.getCookieValue('kxCustomerToken'),
      this.state.language,
      this.state.emailCommunication,
      this.state.textCommunication,
      this.state.shipmentNotification,
      this.state.docChangeNotification,
      this.state.customsResponseNotification,
      this.state.logisticsTrackingNotification,
      this.state.brokerNotification
    ).then(response => {
      return response.json()
    }).then(responseData => {
      console.log(responseData);
    }).then(
      this.setState({ toNextPage: true })
    ).catch(err => console.log('ERROR:', err))

    // this.props.storeProgressData("ai4", "item progress-green")
  }

  handleSkip = () => {
    this.props.storeProgressData("ai4", "piece progress-gray")
  }

  render() {
    const options = [
      { key: 'english', text: 'English', value: 'english' },
      { key: 'french', text: 'French', value: 'french' },
    ]

    const { language } = this.state

    if (this.state.toNextPage === true) {
      this.props.storeProgressData("ai4", "piece progress-green")
			return <Redirect to='/addTeam' />
    }

    return (
      <div>
        <ProgressBar progressData={this.props.progressData}/>
        <h2 className="ai2h2">Settings & Preferences</h2>
        <Segment padded='very' raised className="account-info-4-segment">
          <Form>
            <Form.Field>
              <Form.Field>
                <Header as='h1'>Language Preferences</Header>
                <Dropdown onChange={this.handleChange.bind(this)} name="language" value={language} fluid selection scrolling className='ai4-dropdown' options={options} search placeholder='Select Language'
                />
                <p className="ai4">The user interface will be customized with your above language preference.</p>
                <Header as='h1'>Communication Preferences</Header>
                <p className="ai4">We would like to send you notifications beside delivering them to KlearExpress 
                  Application. Your pick below will keep you informed without logging in to the 
                  Application. Select your prefered communcaition method.</p>
                <Checkbox toggle onChange={this.toggle.bind(this)} name="emailCommunication" className="ai4" label='Emails' value={this.state.emailCommunication}/>
                <p className="ai4">We will send email notifications per your selections below</p>
                <Checkbox toggle onChange={this.toggle.bind(this)} name="textCommunication" className="ai4" label='Text Messages' value={this.state.textCommunication}/>
                <p className="ai4">We will send text messages notifications per your selections below</p>
              </Form.Field>
              
              <Form.Field>
                <Header as='h1'>Notifications</Header>
                <p className="ai4">We will send email notifications per your selections below. 
                  Please choose those options that you want us to inform you about.</p>
                <Checkbox toggle onChange={this.toggle.bind(this)} name="shipmentNotification" className="ai4" label='Shipment Status' value={this.state.shipmentNotification}/>
                <p className="ai4">Status of Shipment includes arrival of Shipments at the key milestones</p>
                <Checkbox toggle onChange={this.toggle.bind(this)} name="docChangeNotification" className="ai4" label='Document Changes' value={this.state.docChangeNotification}/>
                <p className="ai4">Status of key document including changes to key customs documents</p>
                <Checkbox toggle onChange={this.toggle.bind(this)} name="customsResponseNotification" className="ai4" label='Customs Responses' value={this.state.customsResponseNotification} />
                <p className="ai4">Any response that we receive from Customs</p>
                <Checkbox toggle onChange={this.toggle.bind(this)} name="logisticsTrackingNotification"className="ai4" label='Logistics Tracking' value={this.state.logisticsTrackingNotification} />
                <p className="ai4">Location based notification of Shipments from origin to the destination </p>
                <Checkbox toggle onChange={this.toggle.bind(this)} name="brokerNotification" className="ai4" label='Broker Notifications' value={this.state.brokerNotification}/>
                <p className="ai4">You will be notified when the Broker is assigned and any communication the 
                  Broker makes with your team, carrier or freight forwarder</p>
              </Form.Field>

            </Form.Field>
            
            <div className="ai4-buttonRow">
              <Link to='/accountInfo3'>
                <Button type='submit' className="account-info-4-cancel">CANCEL</Button>
              </Link>
              <Link to='/addTeam'>
                <Button type='submit' className="account-info-4-skip">SKIP THIS</Button>
              </Link>
              {/* <Link to='/powerOfAttorney'> */}
                <Button type='submit' className="account-info-4-save" onClick={this.handleSubmit.bind(this)} color="twitter">SAVE & NEXT</Button>
              {/* </Link> */}
            </div>
          </Form>
        </Segment>
      </div>
      // </div>
    );
  }
}

export default AccountInfo3;
